import { graphHooks } from '@tunasong/graph-lib/react'
import { useLayoutsExtended } from '@tunasong/plugin-lib'
import type { Entity, Persisted } from '@tunasong/schemas'
import type { EntityChromeProps } from '@tunasong/tunasong-ui'
import { AppChrome, EntityChrome } from '@tunasong/tunasong-ui'
import type { ContentGroupTabsSpec } from '@tunasong/ui-lib'
import { ContentGroupTabs, useCurrentLayoutName, useParams } from '@tunasong/ui-lib'
import { useEffect, useEffectEvent, useState } from 'react'

/** Wrapper component for the tabbed view */
export const EntityTabsChrome = (props: EntityChromeProps) => {
  const { entity, ...componentProps } = props
  const [content, setContent] = useState<ContentGroupTabsSpec[]>([])

  const updateContentEvent = useEffectEvent((entity?: Persisted<Entity>) => {
    if (!entity) {
      return
    }
    setContent(content => [
      ...content,
      {
        panelType: 'tab',
        entityId: entity.id,
      },
    ])
  })

  useEffect(() => {
    updateContentEvent(entity)
  }, [entity])

  const handleOpen = (newContent: ContentGroupTabsSpec) => {
    // Check if we have the content already
    if (content.find(c => c.entityId === newContent.entityId)) {
      return
    }
    setContent(content => [...content, newContent])
  }
  const handleClose = (oldContent: ContentGroupTabsSpec) =>
    setContent(content => content.filter(c => c.entityId !== oldContent.entityId))
  return (
    <ContentGroupTabs
      content={content}
      alwaysShowTabs={false}
      onOpenContent={handleOpen}
      onCloseContent={handleClose}
      ContentComponent={EntityChrome}
      componentsProps={componentProps}
    />
  )
}

/** Router wrapper for the AppChrome */
export const RouterAppGroupChrome = () => {
  const { entityId } = useParams()

  const layoutName = useCurrentLayoutName()

  const { entity } = graphHooks.useEntity(entityId)
  const layouts = useLayoutsExtended(entity)

  return (
    <AppChrome entity={entity} layouts={layouts} currentLayout={layoutName}>
      <EntityTabsChrome entity={entity} layoutName={layoutName} showSidebar={true} showHeader={true} />
    </AppChrome>
  )
}
